import { useParams } from "react-router-dom";
import TitlePage from "../../../../components/section/TitlePage/Titlepage";

import Navigation from "../Components/navigation";
import { Hospital1on1Table } from "./hospital-1on1-table";

const HospitalDetail1on1Page = () => {
  const { id } = useParams();
  return (
    <div>
      <TitlePage title="회원조회 > 회원상세" />
      <Navigation id="1on1" hospitalId={id} />
      <div className="mt-8">
        <Hospital1on1Table id={id} />
      </div>
    </div>
  );
};

export default HospitalDetail1on1Page;
